import React from 'react';
import { Building2, GraduationCap, Building, Briefcase } from 'lucide-react';
import { Card } from './ui/card';
import { clients } from '../data/mockData';

const clientIcons = {
  'Government Departments': Building2,
  'Educational Institutions': GraduationCap,
  'Public Sector Organizations': Building,
  'Private Enterprises': Briefcase
};

export const OurClients = () => {
  return (
    <section id="clients" className="py-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-3xl sm:text-4xl font-bold text-[#1e3a8a] mb-4">
            Our Clients
          </h2>
          <p className="text-lg text-gray-600">Trusted by leading organizations across sectors</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
          {clients.map((client) => {
            const IconComponent = clientIcons[client.type];
            return (
              <Card key={client.id} className="p-8 text-center bg-white border-gray-200 hover:shadow-xl hover:border-[#1e3a8a] transition-all duration-300">
                <div className="flex justify-center mb-4">
                  <div className="w-16 h-16 bg-[#1e3a8a] bg-opacity-10 rounded-full flex items-center justify-center">
                    <IconComponent className="text-[#1e3a8a]" size={32} />
                  </div>
                </div>
                <h4 className="text-gray-800 font-semibold">{client.type}</h4>
              </Card>
            );
          })}
        </div>

        <p className="text-center text-gray-700 text-lg font-medium">
          Successfully executed multiple GeM orders with accuracy and compliance.
        </p>
      </div>
    </section>
  );
};